/**
 * Navigate to the locale root (e.g. /en, /fi, /sv).
 * Used for clearSearch on non-actionable pages that don't have SearchProvider.
 */
import { navigate } from 'vike/client/router';

export async function navigateToLocaleRoot(locale: string): Promise<void> {
  const path = locale && ['en', 'fi', 'sv'].includes(locale) ? `/${locale}` : '/en';
  await navigate(path);
}
